import React from "react";
import { Link } from "react-router-dom";
import VikingLogo from "../../assets/viking-logo.png";
import SearchIcon from "../SearchIcon/searchIcon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchQuery) {
      navigate(`/search?q=${searchQuery}`);
    }
  };
  return (
    <nav className="bg-white text-black border-b-2 border-gray-300 py-6">
      <div className="container mx-auto flex justify-between items-center px-4 ">
        {/* Logo Section */}
        <div className="flex items-center">
          <Link to="/" className="transform hover:scale-110 transition duration-300 flex items-center text-xl font-serif font-bold">
            <img
              src={VikingLogo}
              alt="Viking Knives Logo"
              className="h-10 w-10 mr-2"
            />
            VIKING KNIVES
          </Link>
        </div>

        {/* Navigation Links */}
        <ul className="flex space-x-6 text-lg">
          <li>
            <Link
              to="/"
              className=" hover:border-b-2 hover:border-black transition duration-300"
            >
              Heim
            </Link>
          </li>
          <li>
            <Link
              to="/shop"
              className=" hover:border-b-2 hover:border-black transition duration-300"
            >
              Verslun
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className=" hover:border-b-2 hover:border-black transition duration-300"
            >
              Um Okkur
            </Link>
          </li>
          <li>
            <Link
              to="/laser-engraving"
              className=" hover:border-b-2 hover:border-black transition duration-300"
            >
              Laser Merkingar
            </Link>
          </li>
          <li>
            <Link
              to="/knives"
              className=" hover:border-b-2 hover:border-black transition duration-300"
            >
              Hnífar
            </Link>
          </li>
        </ul>
        <div className="flex items-right space-x-2">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="p-2 border rounded"
          />
          <button onClick={handleSearch} className="p-2">
            <SearchIcon />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;